import * as React from 'react';
import { memo } from 'react';

const SvgBuildings = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 32 33", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2 27.5h28M18 27.5v-22a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v22M28 27.5v-14a1 1 0 0 0-1-1h-9", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M8 9.5h4M10 17.5h4M8 22.5h4M22 22.5h2M22 17.5h2", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgBuildings);

export { Memo as default };
